<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <task-list :task-lists="taskLists"></task-list>
            </b-col>
            <b-col cols="8">
                <task-group :task-list-id="listId" :tasks="tasks"></task-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Vue from 'vue';
import TaskList from './TaskList';
import TaskGroup from './TaskGroup';
import { mapGetters } from 'vuex';

export default {
    name: 'project-tasks',

    components: { TaskList, TaskGroup },

    data() {
        return {
            listId: null,
            tasks: []
        }
    },

    computed: {
        ...mapGetters({
            taskLists: 'projects/projectTaskLists'
        })
    },

    created() {
        this.getProjectCollaborators();
        this.$store.dispatch('system/loadInputLimits');
    },

    mounted() {
        this.$root.$on('project-tasks::task-list-selected', (payload) => {
            if (!payload.taskList) {
                this.listId = null;
                this.tasks = [];
                return;
            }

            this.listId = payload.taskList.id;
            this.tasks = payload.taskList.tasks;

            this.$router.replace({ query: { listId: this.listId } });

            for (let i = 0; i < this.taskLists.length; i++) {
                Vue.set(this.taskLists[i], '_rowVariant', '');
            }
            Vue.set(payload.taskList, '_rowVariant', 'active');
        });

        this.getTaskLists();
    },

    methods: {
        getProjectCollaborators() {
            this.$store.dispatch('projects/loadCollaboratorsByProject', {
                projectId: this.$route.params.projectId
            });
        },

        getTaskLists() {
            this.$store.dispatch('projects/loadTaskLists', {
                projectId: this.$route.params.projectId
            }).then(() => {
                if (this.$route.name == 'project-tasks') {
                    if (!this.$route.query.listId) {
                        if (this.taskLists.length > 0) {
                            this.tasks = this.taskLists[0].tasks;
                            this.$root.$emit('project-tasks::task-list-selected', { taskList: this.taskLists[0] });
                        }
                    } else {
                        let list = this.taskLists.find(l => l.id === this.$route.query.listId);
                        if (!list) {
                            this.tasks = [];
                        } else {
                            this.tasks = list.tasks;
                            this.$root.$emit('project-tasks::task-list-selected', { taskList: list });
                        }
                    }
                }
            });
        }
    }
}
</script>

<style>
</style>
